function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();

    if (elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': `application/${type}`}
    };
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', {bubbles: true})

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define('quantity-input', QuantityInput);

class CartItems extends HTMLElement {
    constructor() {
        super();

        this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

        this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
            .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

        this.debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, 300);

        this.addEventListener('change', this.debouncedOnChange.bind(this));
    }

    onChange(event) {
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.cart-icon-bubble'
            },
            {
                id: 'main-cart-items',
                section: 'main-cart-items',
                selector: '.main-cart-items'
            },
            {
                id: 'footer-cart-drawer',
                section: 'footer-cart-drawer',
                selector: '.footer-cart-drawer'
            },
            {
                id: 'main-cart-footer',
                section: 'main-cart-footer',
                selector: '.main-cart-footer'
            },
            {
                id: 'main-cart-items-page',
                section: 'main-cart-items-page',
                selector: '.main-cart-items-page'
            }
        ];
    }

    updateQuantity(line, quantity, name) {
        this.enableLoading(line);

        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });

        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{body}})
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                const errorsDiv = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');

                if (parsedState.errors) {
                    errorsDiv.textContent = parsedState.errors;
                    errorsDiv.style.display = 'block';
                } else {

                    //this.classList.toggle('is-empty', parsedState.item_count === 0);
                    const cartDrawerWrapper = document.querySelector('cart-drawer');
                    const reinsuranceCart = document.getElementById('reinsuranceCart');
                    const cartFooter = document.getElementById('main-cart-footer');

                    //On remplace les éléments
                    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

                    this.getSectionsToRender().forEach((section => {
                        const elementsWithId = document.querySelectorAll(`#${section.id}`);
                        elementsWithId.forEach(element => {
                            const elementToReplace = element.querySelector(section.selector) || element;
                            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                        });
                    }));

                    //Couleur du bg du panier.
                    if (parsedState.item_count > 0) {
                        cartDrawerWrapper.style.background = '#ffffff';
                        reinsuranceCart.style.display = 'flex';
                    } else {
                        document.getElementById('cart-drawer').classList.add('is-empty')
                        cartDrawerWrapper.style.background = '#FF7B51';
                        reinsuranceCart.style.display = 'none';
                    }

                    this.disableLoading(line);
                }
            }).catch((e) => {

            this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
            const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
            errors.textContent = window.cartStrings.error;
        }).finally(() => {
            this.disableLoading(line);
        });
    }

    updateLiveRegions(line, itemCount) {
        if (this.currentItemCount === itemCount) {
            const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
            const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
            lineItemError
                .querySelector('.cart-item__error-text')
                .innerHTML = window.cartStrings.quantityError.replace(
                '[quantity]',
                quantityElement.value
            );
        }

        const textareas = document.querySelectorAll('textarea#CartDrawer-Note');

        textareas.forEach(textarea => {
            textarea.addEventListener('input', (event) => {
                // Récupérer le texte tapé par l'utilisateur
                const text = event.target.value;

                // Modifier le contenu de tous les éléments textarea avec l'ID "CartDrawer-Note"
                textareas.forEach(textarea => {
                    textarea.innerText = text;
                });
            });
        });

        this.currentItemCount = itemCount;
        this.lineItemStatusElement.setAttribute('aria-hidden', true);

        const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
        cartStatus.setAttribute('aria-hidden', false);

        setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.add('cursor-not-allowed');

        const cartItemElements = this.querySelectorAll(`#CartItem-${line}`);

        const cartDrawerItemElementsLine = document.getElementById(`CartItem-${line}`);
        cartDrawerItemElementsLine.style.opacity = '.5';

        this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.remove('cursor-not-allowed');

        const cartDrawerItemElementsLine = document.getElementById(`CartItem-${line}`);
        if (cartDrawerItemElementsLine) {
            cartDrawerItemElementsLine.style.opacity = '1';
        }
    }
}

customElements.define('cart-items', CartItems);

class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            event.preventDefault();
            const cartItems = this.closest('cart-drawer-items') || this.closest('cart-items');
            cartItems.updateQuantity(this.dataset.index, 0);
        });
    }
}

customElements.define('cart-remove-button', CartRemoveButton);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        //this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
        mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        modalContent.prepend(newMediaModal);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', {bubbles: true}));
        });
    }

    updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
            if (index === 0) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
            const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
            const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue)
        });
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach(input => {
            if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                input.innerText = input.getAttribute('value');
            } else {
                input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
            }
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        const requestedVariantId = this.currentVariant.id;

        fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                // prevent unnecessary ui changes from abandoned selections
                if (this.currentVariant.id !== requestedVariantId) return;

                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
                const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
                const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

                if (source && destination) destination.innerHTML = source.innerHTML;
                if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
                if (skuSource && skuDestination) {
                    skuDestination.innerHTML = skuSource.innerHTML;
                    skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
                }

                const price = document.getElementById(`price-${this.dataset.section}`);

                if (price) price.classList.remove('visibility-hidden');

                if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

                this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('visibility-hidden');
        if (inventory) inventory.classList.add('visibility-hidden');
        if (sku) sku.classList.add('visibility-hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach(input => {
            if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                input.classList.remove('disabled');
            } else {
                input.classList.add('disabled');
            }
        });
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}

customElements.define('variant-radios', VariantRadios);

/*class NoteOrder extends HTMLElement {
    constructor() {
        super();
        this.typingDelay = 600; // 0,3 seconde
    }

    connectedCallback() {
        const textarea = this.querySelector('textarea');
        if (!textarea) return;

        textarea.addEventListener('input', debounce((event) => {

            console.log(event);

            const body = JSON.stringify({note: event.target.value})

            fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});

        }, this.typingDelay));
    }
}

customElements.define('note-order', NoteOrder);*/

class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
        this.cart = document.querySelector('cart-drawer'); // Assurez-vous que ceci pointe vers votre élément de panier
    }

    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            this.fetchCartAndRecommendations();
        };

        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
    }

    fetchCartAndRecommendations() {
        fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
                if (cart.items.length > 0) {
                    const lastProduct = cart.items[cart.items.length - 1];
                    const recommendationsUrl = `/recommendations/products.json?product_id=${lastProduct.product_id}&limit=4`;
                    return fetch(recommendationsUrl);
                } else {
                    throw new Error('Le panier est vide.');
                }
            })
            .then((response) => response.json())
            .then((data) => this.renderRecommendations(data.products))
            .catch((e) => console.error(e));
    }

    renderRecommendations(products) {
        const recommendationsList = document.getElementById('product-recommendations-list');
        let recommendationsHtml = '';

        products.forEach((product) => {
            let price = this.formatPrice(product.variants[0].price);

            recommendationsHtml += `
                <li class="bg-white h-full min-w-[277px] scroll-mx-6 snap-start rounded p-3.5 grid grid-cols-3 gap-6">
                            <div class="relative h-full w-full bg-gray-100">
                                <img src="${product.images[0]}" alt="${product.title}" class="absolute object-cover h-full w-full">
                            </div>
                            <div class="flex flex-col col-span-2">
                                <div class="flex flex-col">
                                    <span class="text-[#3B3B3B] font-heading text-13 font-[400] tracking-[1.56px] leading-normal uppercase">${product.title}</span>
                                    <span class="text-[#0C0C0C] text-12 font-[380] leading-normal">${price}</span>
                                </div>
                                <div class="mt-auto">
                                    <button data-variant-id="${product.variants[0].id}" class="add-to-cart-btn font-heading text-[#020202] text-10 font-[400] tracking-[1.2px] underline capitalize">
                                        Ajouter
                                    </button>
                                </div>
                            </div>
                        </li>
            `;
        });

        recommendationsList.innerHTML = recommendationsHtml;
        this.attachEventListeners();
    }

    formatPrice(price) {
        // Convertir le prix en un nombre décimal (ex: 5300 devient 53.00)
        let decimalPrice = price / 100;

        // Formater le prix en tant que chaîne de caractères avec deux chiffres après la virgule
        // et remplacer le point par une virgule pour les régions utilisant la virgule comme séparateur décimal
        let formattedPrice = decimalPrice.toFixed(2).replace('.', ',');

        // Ajouter le symbole de l'euro
        return formattedPrice + '€';
    }


    attachEventListeners() {
        document.querySelectorAll('.add-to-cart-btn').forEach(button => {
            button.addEventListener('click', this.addToCart.bind(this));
        });
    }

    addToCart(event) {
        event.preventDefault();
        const variantId = event.target.dataset.variantId;

        console.log(this.cart.getSectionsToRender().map((section) => section.id));

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';
        config.method = 'POST';
        config.body = JSON.stringify({
            items: [{
                id: variantId,
                quantity: 1
            }],
            sections: this.cart.getSectionsToRender().map((section) => section.id)
        });

        fetch(`${routes.cart_add_url}`, config)
            .then(response => response.json())
            .then(data => {
                if (this.cart) {
                    this.cart.renderContents(data);
                }
            })
            .catch((error) => {
                console.error('Erreur lors de l\'ajout du produit:', error);
            });
    }
}

customElements.define('product-recommendations', ProductRecommendations);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this));
    }

    connectedCallback() {
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;

        this.observer.observe(this);

        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.cloneNode(true));

        const deferredElement = content.querySelector('video, model-viewer, iframe');
        if (deferredElement) {
            this.appendChild(deferredElement);
        }
    }

    handleIntersection(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                this.loadContent();
                this.observer.unobserve(this);
            }
        });
    }

    loadContent() {
        if (!this.getAttribute('loaded')) {
            const deferredElement = this.querySelector('video, model-viewer, iframe');
            if (deferredElement && deferredElement.nodeName === 'VIDEO' && deferredElement.getAttribute('autoplay') !== null) {
                // Check if the document has received a user interaction
                const hasUserInteracted = window.matchMedia('(display-mode: standalone)').matches ||
                    window.navigator.userAgent.match(/iPhone|iPod|iPad/) ||
                    window.navigator.userAgent.toLowerCase().includes('android');

                if (hasUserInteracted) {
                    deferredElement.play().catch(error => {
                        console.error('Autoplay failed:', error);
                    });
                } else {
                    // Show a play button or any other interaction prompt to the user
                    // and handle the play action when the user interacts
                    deferredElement.addEventListener('play', () => {
                        // Handle the play action here
                    });
                }
                //Lancement forcé.
                setTimeout(function () {
                    document.querySelectorAll('video').forEach(video => {
                        video.play().catch(error => {
                            console.error('Video autoplay failed:', error);
                        });
                    });
                }, 200);

            }
            this.setAttribute('loaded', true);
        }
    }
}

customElements.define('deferred-media', DeferredMedia);
